<template>
  <div class="home bg-light">
    <SiteNav :login-user="loginUser"/>
    <div class="container-fluid container-3xl py-4.5">
      <a
        id="gridjs-head-btn" class="btn btn-primary py-2 float-end"
        @click.prevent="showEditUserModal(undefined)" role="button"
      >新增使用者</a>
      <div id="gridjs-wrapper"></div>
    </div>
    <!-- 新增/編輯使用者 modal start -->
    <div
      class="modal fade" id="edit-user-modal" tabindex="-1"
      data-bs-backdrop="static" data-bs-keyboard="false"
      aria-labelledby="edit-user-modal-label" aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-md-down"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="edit-user-modal-label">
              {{ createOrUpdate ? '新增使用者' : '編輯使用者' }}
            </h5>
            <button
              type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="取消"
            ></button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <form class="row gx-4 gy-3">
                <div v-show="formErrors.length > 0" class="col-12">
                  <div class="alert alert-danger mb-0 d-flex align-items-center" role="alert">
                    <span class="me-12px"><i class="bi bi-exclamation-circle"></i></span>
                    <span>請輸入{{ formErrors.join('、') }}後，再重新送出</span>
                  </div>
                </div>
                <div v-show="!isUsernameUnique" class="col-12">
                  <div class="alert alert-danger mb-0 d-flex align-items-center" role="alert">
                    <span class="me-12px"><i class="bi bi-exclamation-circle"></i></span>
                    <span>Email 不能和其他使用者重複哦！</span>
                  </div>
                </div>
                <div class="col-12">
                  <label for="username-field" class="form-label">AJA Email</label>
                  <div class="input-group">
                    <input
                      v-model="form.username"
                      type="text"
                      class="form-control"
                      id="username-field"
                      placeholder=""
                    >
                    <span class="input-group-text">
                      @aja.com.tw
                    </span>
                  </div>
                </div>
                <div class="col-12">
                  <label for="password-field" class="form-label">
                    {{ createOrUpdate ? '密碼' : '新密碼（可不填，將延用舊密碼）' }}
                  </label>
                  <div class="input-group">
                    <input
                      v-model="form.password"
                      :type="formShowPassword ? 'text' : 'password'"
                      class="form-control border-end-0"
                      id="password-field"
                      placeholder=""
                    >
                    <span
                      class="input-group-text border-start-0 bg-white"
                      @click="formShowPassword = !formShowPassword"
                      role="button"
                    >
                      <i
                        class="bi"
                        :class="{'bi-eye': formShowPassword, 'bi-eye-slash': !formShowPassword}"
                      ></i>
                    </span>
                  </div>
                </div>
                <div class="col-6">
                  <label for="first-name-field" class="form-label">名字</label>
                  <input
                    v-model="form.first_name"
                    type="text"
                    class="form-control"
                    id="first-name-field"
                    placeholder=""
                  >
                </div>
                <div class="col-6">
                  <label for="last-name-field" class="form-label">姓氏</label>
                  <input
                    v-model="form.last_name"
                    type="text"
                    class="form-control"
                    id="last-name-field"
                    placeholder=""
                  >
                </div>
                <div class="col-12">
                  <label for="role-field" class="form-label">
                    角色&nbsp;
                    <i class="bi bi-info-circle" data-bs-toggle="tooltip"
                       data-bs-placement="top" data-bs-html="true"
                       title="擁有 PM 角色的使用者，將能夠<br>管理專案；擁有 Dir 角色的使用<br>者，將能夠管理專案和使用者。">
                    </i>
                  </label>
                  <multiselect
                    v-model="form.role"
                    :options="['UX', 'UI', 'UR', 'F2E', 'PM', 'Adm', 'Dir']"
                    :allow-empty="true"
                    :show-labels="false"
                    open-direction="above"
                    placeholder="選擇角色 ..."
                    id="role-field"
                  ><span slot="noResult">沒有這個角色唷</span></multiselect>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button" class="btn btn-link btn-link-danger"
              v-if="!createOrUpdate" @click.prevent="showDeleteUserModal"
            >刪除使用者</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
            <button
              type="button" class="btn btn-primary"
              @click.prevent="createOrUpdateUser"
            >{{ createOrUpdate ? '確定新增' : '儲存修改' }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增/編輯使用者 modal end -->
    <!-- 刪除使用者 modal start -->
    <div
      class="modal fade" id="delete-user-modal" tabindex="-1"
      data-bs-backdrop="static" data-bs-keyboard="false"
      aria-labelledby="delete-user-modal-label" aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable max-w-482px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="delete-user-modal-label">
              刪除使用者「{{ deleteUserModalLabel }}」
            </h5>
            <button
              type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="取消"
            ></button>
          </div>
          <div class="modal-body">
            <span class="d-inline-block mb-2">刪除使用者也會將他/她從各個專案成員名單中移除。</span><br>
            <span class="text-muted">開始刪除前，系統會自動檢查這個使用者是否擁有時數，如果有的話，就無法刪除這個使用者。</span>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
            <button
              type="button" class="btn btn-danger"
              @click.prevent="deleteUser"
            >確定刪除</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 刪除使用者 modal end -->
    <!-- 無法刪除 toast start -->
    <div class="position-fixed top-0 start-50 translate-middle-x p-2 z-2k">
      <div
        id="constraint-violation-error"
        class="toast align-items-center toast-danger w-450px"
        role="alert" aria-live="assertive" aria-atomic="true"
      >
        <div class="d-flex">
          <div class="toast-body">
            <div class="d-flex align-items-center">
              <span class="me-12px"><i class="bi bi-exclamation-circle"></i></span>
              <span>無法刪除這筆紀錄，因為這筆紀錄已經在其他地方被使用</span>
            </div>
          </div>
          <button
            type="button" class="btn-close me-2 m-auto"
            data-bs-dismiss="toast" aria-label="關閉"
          ></button>
        </div>
      </div>
    </div>
    <!-- 無法刪除 toast end -->
    <!-- 發生錯誤 toast start -->
    <div class="position-fixed top-0 start-50 translate-middle-x p-2 z-2k">
      <div
        id="create-edit-delete-user-failed"
        class="toast align-items-center toast-danger"
        role="alert" aria-live="assertive" aria-atomic="true"
      >
        <div class="d-flex">
          <div class="toast-body">😭&nbsp;&nbsp;發生了一點錯誤，請稍後再試</div>
          <button
            type="button" class="btn-close me-2 m-auto"
            data-bs-dismiss="toast" aria-label="關閉"
          ></button>
        </div>
      </div>
    </div>
    <!-- 發生錯誤 toast end -->
    <!-- 正在載入使用者 toast start -->
    <div class="position-fixed top-0 start-50 translate-middle-x p-2 z-2k">
      <div
        id="loading-users"
        class="toast align-items-center toast-primary"
        role="alert" aria-live="assertive" aria-atomic="true"
        data-bs-autohide="false"
      >
        <div class="d-flex">
          <div class="toast-body">⏳&nbsp;&nbsp;正在載入使用者&nbsp;...</div>
          <button
            type="button" class="btn-close me-2 m-auto"
            data-bs-dismiss="toast" aria-label="關閉"
          ></button>
        </div>
      </div>
    </div>
    <!-- 正在載入使用者 toast end -->
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { Modal, Toast, Tooltip } from 'bootstrap';
import { Grid, h, html } from 'gridjs';
import 'gridjs/dist/theme/mermaid.css';
import SiteNav from '@/components/SiteNav.vue';
import { fetchApi } from '../utils/index';

export default {
  name: 'Users',
  components: {
    Multiselect,
    SiteNav,
  },
  data() {
    /**
     * @typedef User
     * @type {object}
     * @property {number} id
     * @property {string} username
     * @property {string} first_name
     * @property {string} last_name
     * @property {('UX'|'UI'|'UR'|'F2E'|'PM'|'Adm'|'Dir'|null)} role
     * @property {number} is_active - 1 is true, 0 is false
     * @property {string} created_at - YYYY-MM-DD HH:MM:SS
     * @property {string} updated_at - YYYY-MM-DD HH:MM:SS
     */
    return {
      /** @type {User[]} */
      users: [],
      /** create/update user form data */
      form: {
        username: '',
        password: '',
        first_name: '',
        last_name: '',
        role: '',
      },
      /** @type {string[]} */
      formErrors: [],
      /** @type {boolean} */
      isUsernameUnique: true,
      /** @type {boolean} */
      formShowPassword: false,
      /**
       * true = create user,
       * false = update user
       * @type {boolean}
       */
      createOrUpdate: true,
      /** API action createUser/updateUser/deleteUser's parameters */
      modifyUserParams: {
        id: -1,
      },
      /** @type {Grid} */
      grid: null,
      /** currently logged-in user */
      loginUser: {
        id: -1,
        first_name: '',
        last_name: '',
        role: '',
      },
    };
  },
  computed: {
    /** @type {string} */
    deleteUserModalLabel() {
      const userId = Object.prototype.hasOwnProperty.call(this.modifyUserParams, 'id')
        ? this.modifyUserParams.id
        : -1;
      const foundUser = this.users.find((user) => user.id === userId);
      return foundUser ? `${foundUser.first_name} ${foundUser.last_name}` : '';
    },
  },
  methods: {
    /** @param {Error} error */
    displayErrorToast(error) {
      /* eslint-disable operator-linebreak, indent */
      const toastElement =
        (error.message.includes('Constraint Violation') || error.message.includes('(2.1)'))
        ? document.querySelector('#constraint-violation-error')
        : document.querySelector('#create-edit-delete-user-failed');
      /* eslint-enable operator-linebreak, indent */
      const toast = Toast.getOrCreateInstance(toastElement);
      toast.show();
      // eslint-disable-next-line no-console
      console.error('Error Details:', error);
    },
    renderGridjs() {
      const gridjsWrapper = document.querySelector('#gridjs-wrapper');
      this.grid = new Grid({
        columns: [
          '姓名',
          'AJA Email',
          '角色',
          {
            id: 'is_active',
            name: html(`
              啟用&nbsp;
              <i class="bi bi-info-circle" data-bs-toggle="tooltip"
                 data-bs-placement="top" data-bs-html="true"
                 title="啟用這個使用者，將允許他/她<br>登入這個系統，系統管理員也<br>可以將他/她指派到新的專案。">
              </i>
            `),
            sort: false,
            width: '110px',
          },
          {
            name: '建立時間',
            width: '140px',
          },
          {
            name: '更新時間',
            width: '140px',
          },
          {
            id: 'actions',
            name: '',
            sort: false,
            width: '100px',
          },
        ],
        sort: true,
        search: true,
        pagination: {
          enabled: true,
          page: 0,
        },
        data: this.users.map((user, idx) => [
          `${user.first_name} ${user.last_name}`,
          user.username,
          user.role || '( 無 )',
          h('div', { className: 'text-center' },
            h('input', {
              type: 'checkbox',
              id: `switch-${idx}`,
              className: 'switch-input',
              ...(user.is_active && { checked: 'checked' }),
              onChange: () => this.toggleUserActiveState(`switch-${idx}`, user),
            }),
            h('label', {
              for: `switch-${idx}`,
              className: 'switch-label',
            }),
          ), // eslint-disable-line function-paren-newline
          user.created_at.substring(0, 10),
          user.updated_at.substring(0, 10),
          h('div', { className: 'text-center' },
            h('button', {
              className: 'btn btn-secondary btn-sm',
              onClick: () => this.showEditUserModal(user),
            }, h('i', { className: 'bi bi-pencil-fill' })),
          ), // eslint-disable-line function-paren-newline
        ]),
        style: {
          table: {
            width: '100%',
          },
          th: {
            'border-left-width': '0',
            'border-right-width': '0',
          },
          td: {
            'border-left-width': '0',
            'border-right-width': '0',
            'white-space': 'nowrap',
          },
        },
        language: {
          search: {
            placeholder: '🔍  搜尋使用者 ...',
          },
          sort: {
            sortAsc: '從 A 到 Z 排序',
            sortDesc: '從 Z 到 A 排序',
          },
          pagination: {
            previous: '⟨',
            next: '⟩',
            showing: ' ',
            of: '列（ 共',
            to: '–',
            results: '列 ）',
          },
          loading: '⏳  正在載入使用者 ...',
          noRecordsFound: '找不到符合的使用者',
          error: '😭  發生了一點錯誤，請稍後再試',
        },
      }).render(gridjsWrapper);
      const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      // eslint-disable-next-line no-restricted-syntax
      for (const tooltipElement of tooltipElements) Tooltip.getOrCreateInstance(tooltipElement);
      const gridjsHead = document.querySelector('.gridjs-head');
      const gridjsHeadBtn = document.querySelector('#gridjs-head-btn');
      gridjsHead.appendChild(gridjsHeadBtn);
    },
    /** @param {number} initialPageNo - initial page number, starts from 0 */
    updateGridjs(initialPageNo = 0) {
      const gridjsHeadBtn = document.querySelector('#gridjs-head-btn');
      const totalPages = Math.ceil(this.users.length / 10);
      this.grid.updateConfig({
        pagination: {
          enabled: true,
          page: Math.max(0, Math.min(initialPageNo, totalPages - 1)),
        },
        data: this.users.map((user, idx) => [
          `${user.first_name} ${user.last_name}`,
          user.username,
          user.role || '( 無 )',
          h('div', { className: 'text-center' },
            h('input', {
              type: 'checkbox',
              id: `switch-${idx}`,
              className: 'switch-input',
              ...(user.is_active && { checked: 'checked' }),
              onChange: () => this.toggleUserActiveState(`switch-${idx}`, user),
            }),
            h('label', {
              for: `switch-${idx}`,
              className: 'switch-label',
            }),
          ), // eslint-disable-line function-paren-newline
          user.created_at.substring(0, 10),
          user.updated_at.substring(0, 10),
          h('div', { className: 'text-center' },
            h('button', {
              className: 'btn btn-secondary btn-sm',
              onClick: () => this.showEditUserModal(user),
            }, h('i', { className: 'bi bi-pencil-fill' })),
          ), // eslint-disable-line function-paren-newline
        ]),
      }).forceRender();
      const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      // eslint-disable-next-line no-restricted-syntax
      for (const tooltipElement of tooltipElements) Tooltip.getOrCreateInstance(tooltipElement);
      const gridjsHead = document.querySelector('.gridjs-head');
      gridjsHead.appendChild(gridjsHeadBtn);
    },
    /** @param {User} [user] */
    showEditUserModal(user) {
      if (user === undefined) {
        this.form = {
          username: '',
          password: '',
          first_name: '',
          last_name: '',
          role: '',
        };
        this.createOrUpdate = true; // create user
        this.modifyUserParams.id = null;
      } else {
        this.form = {
          username: user.username.endsWith('@aja.com.tw') ? user.username.slice(0, -11) : user.username,
          password: '',
          first_name: user.first_name,
          last_name: user.last_name,
          role: user.role || '',
        };
        this.createOrUpdate = false; // update user
        this.modifyUserParams.id = user.id;
      }
      this.formErrors = [];
      this.isUsernameUnique = true;
      const modalElement = document.querySelector('#edit-user-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.show();
    },
    showDeleteUserModal() {
      let modalElement;
      let modal;
      modalElement = document.querySelector('#edit-user-modal');
      modal = Modal.getOrCreateInstance(modalElement);
      modal.hide();
      modalElement = document.querySelector('#delete-user-modal');
      modal = Modal.getOrCreateInstance(modalElement);
      modal.show();
    },
    createOrUpdateUser() {
      const formErrors = [];
      if (this.form.username.length === 0) formErrors.push('AJA Email');
      if (this.createOrUpdate && this.form.password.length === 0) formErrors.push('密碼');
      if (this.form.first_name.length === 0) formErrors.push('名字');
      if (this.form.last_name.length === 0) formErrors.push('姓氏');
      if (formErrors.length > 0) {
        this.formErrors = formErrors;
        return;
      }
      this.formErrors = [];
      if (this.createOrUpdate === true) {
        // condition: create user
        this.modifyUserParams = {
          ...this.modifyUserParams,
          username: this.form.username.endsWith('@aja.com.tw') ? this.form.username : `${this.form.username}@aja.com.tw`,
          password: this.form.password,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          role: this.form.role || null,
        };
        this.isUsernameUnique = !this.users.some(
          (user) => user.username === this.modifyUserParams.username,
        );
        if (!this.isUsernameUnique) return;
        fetchApi('createUser', this.modifyUserParams)
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            return fetchApi('getAllUsers');
          })
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            this.users = data.results;
            this.updateGridjs();
          })
          .catch((error) => {
            this.displayErrorToast(error);
          });
      } else {
        // condition: update user
        const foundUser = this.users.find(
          (user) => user.id === this.modifyUserParams.id,
        );
        this.modifyUserParams = {
          ...this.modifyUserParams,
          username: this.form.username.endsWith('@aja.com.tw') ? this.form.username : `${this.form.username}@aja.com.tw`,
          password: this.form.password || null,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          role: this.form.role || null,
          is_active: foundUser.is_active,
        };
        this.isUsernameUnique = !this.users.some(
          (user) => user.id !== this.modifyUserParams.id
                 && user.username === this.modifyUserParams.username,
        );
        if (!this.isUsernameUnique) return;
        fetchApi('updateUser', this.modifyUserParams)
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            return fetchApi('getAllUsers');
          })
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            const pageNo = this.findPageNo(this.modifyUserParams.id);
            this.users = data.results;
            this.updateGridjs(pageNo);
          })
          .catch((error) => {
            this.displayErrorToast(error);
          });
      }
      const modalElement = document.querySelector('#edit-user-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.hide();
    },
    /**
     * @param {string} elementId
     * @param {User} user
     */
    toggleUserActiveState(elementId, user) {
      const checkbox = document.getElementById(elementId);
      const newUser = {
        ...user,
        is_active: checkbox.checked ? 1 : 0,
      };
      fetchApi('updateUser', newUser)
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          return fetchApi('getAllUsers');
        })
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          const pageNo = this.findPageNo(newUser.id);
          this.users = data.results;
          this.updateGridjs(pageNo);
        })
        .catch((error) => {
          this.displayErrorToast(error);
        });
    },
    deleteUser() {
      fetchApi('deleteUser', this.modifyUserParams)
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          return fetchApi('getAllUsers');
        })
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          const pageNo = this.findPageNo(this.modifyUserParams.id);
          this.users = data.results;
          this.updateGridjs(pageNo);
        })
        .catch((error) => {
          this.displayErrorToast(error);
        });
      const modalElement = document.querySelector('#delete-user-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.hide();
    },
    /**
     * 計算這個使用者會出現在列表的第幾頁
     * @param {number} userId - 使用者的 ID
     * @returns {number|undefined}
     */
    findPageNo(userId) {
      const idx = this.users.findIndex((user) => user.id === userId);
      const pageNo = Math.ceil((idx + 1) / 10) - 1;
      // we need to minus 1 because pageNo starts from 0
      return (pageNo >= 0) ? pageNo : undefined;
    },
  },
  mounted() {
    const toastElement = document.querySelector('#loading-users');
    const loadingToast = Toast.getOrCreateInstance(toastElement);
    fetchApi('getLoggedInUser')
      .then((data) => {
        if (data.status === -1) {
          this.$router.push('/login');
        }
        if (data.status !== 0) {
          throw new Error(`${data.message} (${data.status})`);
        }
        const { results } = data;
        [this.loginUser] = results;
        loadingToast.show();
      })
      .then(() => Promise.all([
        fetchApi('getAllUsers'),
      ]))
      .then((dataList) => {
        const resultsList = [];
        dataList.forEach((data) => {
          if (data.status === -1) {
            loadingToast.hide();
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          resultsList.push(data.results);
        });
        [this.users] = resultsList;
        this.renderGridjs();
        loadingToast.hide();
      })
      .catch((error) => {
        loadingToast.hide();
        this.displayErrorToast(error);
      });
  },
};
</script>

<style lang="scss">
@import "../utils/toggle-switch";
.tooltip .tooltip-inner {
  max-width: 250px;
}
</style>

<style scoped lang="scss">
@import "~bootstrap/scss/bootstrap-grid";
.container-fluid {
  @include media-breakpoint-up(md) {
    padding-left: 48px;
    padding-right: 48px;
  }
}
.container-3xl {
  @media (min-width: 1441px) {
    max-width: 1440px;
  }
}
.btn-link-danger {
  text-decoration: none;
  padding-left: 6px;
  padding-right: 6px;
  margin-right: auto;
  color: #dc3545;
  &:hover {
    color: #bb2d3b;
  }
}
::v-deep #edit-user-modal .multiselect__tags {
  height: 40px;
}
::v-deep .gridjs-search-input {
  @include media-breakpoint-down(md) {
    width: 220px;
  }
}
</style>
